function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "star",
  clipPath: "url(#clip0_30_375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M11.3385 0.962576C11.4627 0.710838 11.7191 0.551468 11.9998 0.551468C12.2806 0.551419 12.537 0.710789 12.6613 0.962528L15.5382 6.79084C15.8087 7.33887 16.3316 7.71881 16.9364 7.80666L23.3686 8.74169C23.6465 8.78211 23.8773 8.97668 23.9641 9.24371C24.0508 9.51069 23.9785 9.80382 23.7775 9.9998L19.1234 14.537C18.6858 14.9637 18.4861 15.5783 18.5893 16.1806L19.6875 22.586C19.7349 22.8627 19.6211 23.1423 19.394 23.3072C19.1669 23.4723 18.8658 23.494 18.6173 23.3633L12.864 20.3393C12.3231 20.0549 11.6768 20.0549 11.1357 20.3394L5.38296 23.3633C5.13444 23.4939 4.83333 23.4721 4.60623 23.3071C4.37908 23.1421 4.26538 22.8624 4.31281 22.5858L5.41145 16.1809C5.51482 15.5784 5.31509 14.9637 4.87734 14.5369L0.223001 9.99985C0.0219997 9.80386 -0.0504056 9.51074 0.0363639 9.24376C0.123133 8.97678 0.353934 8.7822 0.631772 8.74174L7.06382 7.80675C7.66867 7.71881 8.19158 7.33892 8.46211 6.79079L11.3385 0.962576Z",
  fill: "#373737"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_30_375"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6f744cc4.svg";
export { ForwardRef as ReactComponent };